//
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class ContentAnchors extends WebComponent {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
		this.handlePageScroll = this.handlePageScroll.bind(this);
		this.getOffsetTop = this.getOffsetTop.bind(this);
		this.addBodyOffset = this.addBodyOffset.bind(this);
		this.removeBodyOffset = this.removeBodyOffset.bind(this);
		this.fixedState = false;
		this.positionY = 0;
	}

	didMount() {
		const {
			childSelector,
			clickSelector,
			activeClass,
			fixedOnScroll,
		} = this.props;

		this.activeClass = activeClass;
		this.targetElements = this.element.querySelectorAll(childSelector);
		this.body = document.querySelector('body');

		if (this.targetElements.length > 0) {
			this.clickElements = this.element.querySelectorAll(clickSelector);
			this.activeElement = this.element.querySelector(childSelector + '.' + activeClass);

			if ((!this.activeElement) && (this.targetElements)) {
				this.activeElement = this.targetElements[0];
				this.activeElement.classList.add(activeClass);
			}

			Array.from(this.clickElements).forEach(link => {
				link.addEventListener('click', this.handleClick);
			});

			if (fixedOnScroll) {
				this.getOffsetTop();
				this.handlePageScroll;

				window.addEventListener('scroll', this.handlePageScroll);
				window.addEventListener('orientationchange', this.getOffsetTop);
			}
		}
	}

	willUnMount() {
		window.removeEventListener('scroll', this.handlePageScroll);
		window.removeEventListener('orientationchange', this.getOffsetTop);
		Array.from(this.clickElements).forEach(link => {
			link.removeEventListener('click', this.handleClick);
		});
	}

	handleClick(e) {
		e.preventDefault();

		const target = (document.querySelector(e.target.getAttribute('href')));
		let topOfElement = 0;
		const {
			fixedOnScroll,
		} = this.props;

		if (target) {

			if (fixedOnScroll) {
				topOfElement = target.offsetTop - (this.getHeight() + 80);
			}
			else {
				topOfElement = target.offsetTop;
			}
			window.scroll({ top: topOfElement, behavior: 'smooth' });
		}


		this.removeAllActive();
		e.target.parentNode.classList.add(this.activeClass);
	}

	removeAllActive = () => {
		Array.from(this.targetElements).forEach(target => {
			target.classList.remove(this.activeClass);
		});
	}
	handlePageScroll(e) {
		const {
			fixedClass,
		} = this.props;

		let windowPosition = window.pageYOffset;

		if (this.fixedState) {
			windowPosition = window.pageYOffset + this.getHeight();
		}

		if (windowPosition >= this.offsetTop) {
			if (!this.fixedState) {
				this.element.classList.add(fixedClass);
				this.addBodyOffset();
				this.fixedState = true;
			}
		}
		else {
			if (this.fixedState) {
				this.removeBodyOffset();
				this.element.classList.remove(fixedClass);
				this.fixedState = false;
			}
		}

		let activeAnchor = this.element.querySelector("."+this.activeClass);
		if(activeAnchor != null && activeAnchor.querySelector("a") != null) {
			let activeAnchorHref = activeAnchor.querySelector("a").getAttribute("href");
			let activeAnchorId = 1;
			if(activeAnchor) {
				activeAnchorId = parseInt(activeAnchor.getAttribute("data-id"));
			}

			let iter = 0;
			if(window.scrollY < this.positionY) {
				iter = -1;
			} else if (window.scrollY > this.positionY) {
				iter =  +1
			}
			let nextAnchor = document.querySelector(activeAnchorHref);
			if(nextAnchor) {
				let nextAnchorTop = nextAnchor.getBoundingClientRect().top;
				if(nextAnchorTop < 100) {
					let nextAnchorItem = this.element.querySelector(`.content-anchors__item[data-id="${activeAnchorId+iter}"]`);
					if(nextAnchorItem) {
						nextAnchorItem.classList.add(this.activeClass);
						if(activeAnchor){
							activeAnchor.classList.remove(this.activeClass);
						}
					}
				}
			}
		}


		this.positionY = window.scrollY;

	}

	getHeight() {
		const styles = window.getComputedStyle(this.element);
		const margin = parseFloat(styles['marginTop']) +
				parseFloat(styles['marginBottom']);

		return Math.ceil(this.element.offsetHeight + margin);
	}

	addBodyOffset() {
		this.body.style.paddingTop = this.getHeight() + 'px';
	}

	removeBodyOffset() {
		this.body.style.paddingTop = 0;
	}
	getOffsetTop() {
		this.removeBodyOffset();
		this.offsetTop = this.element.getBoundingClientRect().top + window.pageYOffset;
	}
}

ContentAnchors.defaultProps = {
	childSelector: 'li',
	clickSelector: 'li a',
	activeClass: 'content-anchors__item--active',
	fixedOnScroll: true,
	fixedClass: 'content-anchors__list--fixed',
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ContentAnchors.js